"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ProductTileGrid;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _productListingContext = require("../product-listing-context");
var _productTile = _interopRequireDefault(require("../product-tile"));
var _spinner = _interopRequireDefault(require("../../../other/spinner"));
var _merchButton = require("@site/pattern-library-core/merch-button");
var _motionFunctions = require("@site/pattern-library-core/motion-functions");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable max-statements */

const TileSectionWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "TileSectionWrapper",
  class: "pl-t17njby0",
  vars: {
    "t17njby0-0": [({
      dynamicHeight
    }) => dynamicHeight]
  }
});
const TileSection = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "TileSection",
  class: "pl-t1rgx5ih"
});
const TileGrid = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "TileGrid",
  class: "pl-t1e2ix07"
});
const TileCount = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "TileCount",
  class: "pl-t9u6n5k",
  vars: {
    "t9u6n5k-0": [({
      hide
    }) => hide ? 'none' : 'inline-flex']
  }
});
const Tile = /*#__PURE__*/(0, _react2.styled)(_productTile.default)({
  name: "Tile",
  class: "pl-ttjxbq1",
  vars: {
    "ttjxbq1-0": [({
      hide
    }) => hide ? 'none' : 'flex']
  }
});

/**
 * Render the product tile grid.
 * @memberof module:ProductListingSection
 * @param {object} props React props
 * @param {number} props.tilesPerPage Number of tiles to display
 * @param {string} props.ctaTileText CTA text
 * @param {string} props.showingTileText Pagination text
 * @param {object} props.tileGridRef Pagination text
 * @param {string} props.containerHeight Pagination text
 * @param {number} props.lastIndex Pagination text
 * @param {function} props.setLastIndex Pagination text
 * @returns {React.ReactElement} Product tile grid
 */
function ProductTileGrid({
  tilesPerPage = 9,
  isLoading,
  ctaTileText = 'Show More',
  showingTileText = 'Showing {QTY} of {TOTAL}',
  tileGridRef,
  containerHeight,
  lastIndex,
  setLastIndex
}) {
  const {
    activeCategory,
    categories,
    productTiles,
    setProductTiles,
    tags,
    businesses,
    setDataBusiness,
    setDataTags,
    userInteracted,
    setSelectorCustomProperties,
    dataCategory
  } = (0, _react.useContext)(_productListingContext.ProductListingContext);
  const [renderedTiles, setRenderedTiles] = (0, _react.useState)(productTiles);

  // Tag Filtering
  (0, _patternLibraryUtils.useIsomorphicLayoutEffect)(() => {
    const hasFeaturedProduct = renderedTiles?.filter(tile => tile.isFeaturedProductTile && tile.featuredCategory?.Text === activeCategory.name?.Text).length > 0;
    const last = hasFeaturedProduct ? tilesPerPage - 1 : tilesPerPage;
    last > renderedTiles.length ? setLastIndex(renderedTiles.length) : setLastIndex(last);
  }, [renderedTiles, tilesPerPage, activeCategory]);
  const showMore = () => {
    const last = lastIndex + tilesPerPage;
    last > renderedTiles.length ? setLastIndex(renderedTiles.length) : setLastIndex(last);
  };
  const hasActiveFilters = () => {
    return tags?.filter(t => t.isActive).length > 0 || businesses?.filter(b => b.isActive).length > 0;
  };

  // Category Filtering
  (0, _patternLibraryUtils.useIsomorphicLayoutEffect)(() => {
    if (!userInteracted) {
      const tiles = categories.reduce((allTiles, {
        productTiles: catTiles
      }) => {
        allTiles.push(...catTiles);
        return allTiles;
      }, []);
      setRenderedTiles(tiles);
    } else if (!hasActiveFilters()) {
      setRenderedTiles(productTiles);
    } else {
      const filteredTiles = productTiles?.filter(tile => tile.isVisible);
      setLastIndex(Math.min(filteredTiles.length, tilesPerPage));
      setRenderedTiles(filteredTiles);
    }
  }, [productTiles, categories, tags, businesses, userInteracted]);

  // toggle the visibility of the tiles with active tags or businesses
  (0, _patternLibraryUtils.useIsomorphicLayoutEffect)(() => {
    const activeTagLabels = tags?.filter(t => t.isActive).map(t => t.tagName.Text);
    const activeBusinessLabels = businesses?.filter(b => b.isActive).map(b => b.businessName.Text);
    if (activeTagLabels?.length > 0 || activeBusinessLabels.length > 0) {
      const filteredTiles = productTiles?.map(tile => {
        let isVisible = false;
        tile.productTags?.forEach(tag => {
          if (activeTagLabels.includes(tag.tagName.Text)) {
            isVisible = true;
          }
        });
        tile.businessType?.forEach(business => {
          if (activeBusinessLabels.includes(business.businessName.Text)) {
            isVisible = true;
          }
        });
        return {
          ...tile,
          isVisible
        };
      });
      setProductTiles(filteredTiles);
    }
    const dataTags = (0, _patternLibraryUtils.stringifyArray)(activeTagLabels?.map(t => 'tag_' + t));
    const dataBusiness = (0, _patternLibraryUtils.stringifyArray)(activeBusinessLabels?.map(b => 'business_' + b));
    setDataTags(dataTags);
    setDataBusiness(dataBusiness);
    setSelectorCustomProperties({
      plp_category_selected: dataCategory,
      plp_tags_selected: dataTags,
      plp_business_selected: dataBusiness
    });
  }, [tags, businesses]);
  return /*#__PURE__*/_react.default.createElement(TileSectionWrapper, {
    dynamicHeight: containerHeight
  }, isLoading ? /*#__PURE__*/_react.default.createElement(_spinner.default, {
    size: "lg",
    centerHorizontally: true
  }) : /*#__PURE__*/_react.default.createElement(TileSection, {
    "data-cy": "tile-section"
  }, /*#__PURE__*/_react.default.createElement(TileGrid, {
    ref: tileGridRef
  }, renderedTiles?.map((tile, i) => /*#__PURE__*/_react.default.createElement(Tile, (0, _extends2.default)({
    key: i,
    gridIndex: i
  }, tile, {
    hide: lastIndex <= i
  })))), /*#__PURE__*/_react.default.createElement(TileCount, {
    hide: lastIndex === 0
  }, showingTileText && /*#__PURE__*/_react.default.createElement("p", null, showingTileText.replace('{QTY}', lastIndex).replace('{TOTAL}', renderedTiles.length)), lastIndex < renderedTiles.length && /*#__PURE__*/_react.default.createElement(_merchButton.NSMerchButton, {
    design: "merch",
    "data-cy": "show-more-button",
    isPromo: false,
    size: "default",
    onClick: showMore,
    text: ctaTileText
  }))));
}
ProductTileGrid.propTypes = {
  tilesPerPage: _propTypes.default.number,
  isLoading: _propTypes.default.bool,
  ctaTileText: _propTypes.default.string,
  showingTileText: _propTypes.default.string,
  tileGridRef: _propTypes.default.object,
  containerHeight: _propTypes.default.string,
  lastIndex: _propTypes.default.number,
  setLastIndex: _propTypes.default.func
};